import { HIDE_CHATBOT_EP_LABEL_ID } from '../constants';

type ArticleWithLabels = { labels?: { id?: string }[] };

export const toArticleLabels = (labelIds?: string[]): { id: string }[] =>
  (labelIds ?? []).map((id) => ({ id }));

export const hasHideChatbotEpLabel = (article: ArticleWithLabels): boolean =>
  !!article.labels?.some((label) => label.id === HIDE_CHATBOT_EP_LABEL_ID);
